<template>
  <div class="payment-card">
    <h1 class="text-center page-title" style="color: hsla(0, 0%, 100%, .8); padding-top: 40px">Баримт авах төрөл өө
      сонгоно уу</h1>

    <Button @click="navigateToAan" style="background: grey;color: hsla(0, 0%, 100%, .8); margin-bottom: 10px">
      Байгууллага
    </Button>
    <Button @click="paymentChoose" style="background: grey;color: hsla(0, 0%, 100%, .8)">Хувь хүн</Button>

  </div>
</template>
<script>

export default {
  name: "card.vue",
  data() {
    return {
      btnLoading: false,
      error: false,
      success: false,
      code: "",
      msg: ""
    }
  },
  methods: {
    navigateToAan() {
      this.$router.push('/aan');
    },
    paymentChoose() {
      this.$router.push("/payment");
    },
  }
}
</script>
